
<div class="kudos-badge"><span>{{'kudos.type.'+task.kudosType | translate}} - </span>{{'Kudos' | translate }}</div>
<div class="card-top pe-2">
    @switch (task.kudosType){
        @case ('thanks'){
            <i class="fa-light fa-hands-holding-heart hands-holding-heart-icon ms-2 position-relative text-secondary"></i>
        }
        @case ('congratulate'){
            <i class="fa-light fa-hands-clapping fa-2x ms-2 position-relative text-secondary"></i>
        }
        @case ('celebrate'){
            <i class="fa-sharp fa-light fa-party-horn fa-2x ms-2 position-relative text-secondary"></i>
        }
    }
    <tm-kudos-recipients-display [recipients]="task.recipients" [author]="task.author"></tm-kudos-recipients-display>
</div>
<div class="card-top py-0 mx-3">
    <div class="card-comment p-3">
        <span class="card-comment-body fst-italic" [innerHtml]="task?.message?.body | removeGifUrls: task?.message?.linkPreviews | linky"></span>
        @for (linkPreview of task.message.linkPreviews; track linkPreview.url){
            @if(linkPreview.url.slice(-4) === '.gif'){
            <tm-gif-preview [gifPreview]="toGifPreview(linkPreview)"></tm-gif-preview>
            }
        }
    </div>
    <div class="card-options">
        <div data-cy="report-comment" (click)="reportItem()">
            <i class="fa-regular fa-hexagon-exclamation"
               [matTooltip]="'comment-card.options.report' | translate"
               matTooltipPosition="right"></i>
        </div>
    </div>
</div>

@for(linkPreview of task.message.linkPreviews; track linkPreview.url){
    @if(linkPreview.url.slice(-4) !== '.gif'){
    <div>
        <tm-link-preview [linkPreview]="linkPreview"></tm-link-preview>
    </div>
    }
}


        
                